<template>
    <div class="social-media-card">
        <div class="social-content">
            <div class="media" v-show="images.length">
                <img-swiper
                    class="images-swiper"
                    ref="imgSwiper"
                    @change="onPreviewChange"
                    @load="onImageLoad"
                    :style="{ height: imgHeight + 'px' }"
                    :allImagesJson="imagesJson"
                    :alt="content"
                    dir="width"
                >
                    <template #button-prev>
                        <div
                            class="swiper-prev"
                            @click.stop.prevent="changePreview($event, 'prev')"
                            v-show="!isMobileDevice && previewIndex > 0"
                        >
                            <div class="bg"></div>
                            <i class="iconfont icon-chevron_right" />
                        </div>
                    </template>
                    <template #button-next>
                        <div
                            @click.stop.prevent="changePreview($event, 'next')"
                            class="swiper-next"
                            v-show="
                                !isMobileDevice &&
                                    previewIndex < images.length - 1
                            "
                        >
                            <div class="bg"></div>
                            <i class="iconfont icon-chevron_right" />
                        </div>
                    </template>
                    <template #mask>
                        <div class="dot-mask" v-show="images.length > 1">
                            <div
                                class="dot"
                                v-for="(_, idx) in images"
                                :key="idx"
                                :class="{ active: idx == previewIndex }"
                            />
                        </div>
                    </template>
                </img-swiper>
            </div>
            <div class="text">{{ content }}</div>
            <div class="time-source">
                <p class="time">
                    <only-client>{{ $ft.formatDate(createTime, 'MMM dd, yyyy') }}</only-client>
                </p>
                <a :href="url" target="_blank" rel="noopener noreferrer" :aria-label="sourceClass">
                    <i
                        v-if="socialType != Tiktok_TYPE"
                        class="iconfont source"
                        :class="sourceClass"
                        :style="sourceStyle"
                    ></i>
                    <div v-else class="icon-tiktok-round"></div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
const Tiktok_TYPE = 5;
export default {
    emits: ['update:height'],
    props: {
        images: {
            type: Array,
            default: () => {
                return [];
            }
        },
        content: String,
        createTime: Number,
        socialType: Number,
        url: String,
        channelId: [String, Number],
        pageName: String
    },
    components: {
        imgSwiper: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "common/img-swiper" */ '@/components/img-swiper.vue'
            ))
    },
    data: function() {
        return {
            imageWH: {
                naturalWidth: 0,
                naturalHeight: 0,
                id: ''
            },
            width: 235,
            previewIndex: 0,
            isMobileDevice: this.platform.isMobile,
            Tiktok_TYPE
        };
    },
    computed: {
        imagesJson() {
            return JSON.stringify(this.images)
        },
        imgHeight() {
            let calcHeight = Math.ceil(this.width);
            if (this.imageWH.naturalWidth) {
                calcHeight = Math.ceil(
                    (this.imageWH.naturalHeight * this.width) /
                        this.imageWH.naturalWidth
                );
            }
            return Math.min(300, Math.max(calcHeight, 210));
        },
        sourceClass() {
            switch (this.socialType) {
            case 1:
                return 'icon-instagram-round';
            case 0:
                return 'icon-facebook-round';
            case 2:
                return 'icon-newtwitter-round';
            case 3:
                return 'icon-linkedin-round';
            case 4:
                return 'icon-youtube-fill';
            case 5:
                return 'icon-tiktok-round';
            case 6:
                return 'icon-facebook-round';
            case 7:
                return 'icon-google-plus-round';
            }
            return '';
        },
        sourceStyle() {
            switch (this.socialType) {
            case 1:
                return {
                    'background-image': 'linear-gradient(44deg, #f7de01 6%, #f92002 40%, #dd1e49 52%, #b12973 62%, #7837aa 87%)',
                    'background-clip': 'text',
                    '-webkit-background-clip': 'text',
                    color: 'transparent'
                };
            case 0:
                return { color: '#384891' };
            case 2:
                return { color: '#1daef3' };
            case 3:
                return { color: '#2f8ad9' };
            case 4:
                return { color: '#ed0a0a' };
            case 5:
                return { color: '#000000' };
            case 6:
                return { color: '#384891' };
            case 7:
                return { color: '#4ea3f0' };
            }
            return '';
        }
    },
    mounted() {
        this.tellOutterHeight();
    },
    methods: {
        onImageLoad(event) {
            let { width, height } = event || {};
            if (this.imageWH.id == this.channelId) {
                return;
            }
            // only fetch the current id of post The height and width of the first loaded image
            this.imageWH.naturalWidth = width;
            this.imageWH.naturalHeight = height;
            this.imageWH.id = this.channelId;
            this.tellOutterHeight();
        },
        tellOutterHeight() {
            this.$nextTick(_ => {
                this.width = this.$el.clientWidth;
                return this.$emit('update:height', this.$el.offsetHeight);
            });
        },
        onPreviewChange(idx) {
            this.previewIndex = idx - 1;
        },
        changePreview(event, command) {
            if (!this.$refs.imgSwiper) {
                return;
            }
            this.$refs.imgSwiper.switchImg(event, command);
        }
    }
};
</script>
<style lang="scss">
.social-media-card {
    display: block;
    border-radius: 0;
    border: solid 1px #dadada;
    background: #fff;
    border-radius: 5px;
    overflow: hidden;
    font-family: var(--font-normal);
    display: block;
    .images-swiper {
        position: relative;
        width: 100%;
        .swiper-prev,
        .swiper-next {
            position: absolute;
            width: 26px;
            height: 26px;
            overflow: hidden;
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
            color: #fff;
            cursor: pointer;
            .iconfont {
                font-size: 14px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(calc(-50% + 2px), -50%);
            }
            .bg {
                background-color: rgba(0, 0, 0, 0.3);
                width: 100%;
                height: 100%;
            }
            &.swiper-button-disabled {
                opacity: 0.5;
            }
            &:hover {
                box-shadow: 0 8px 20px 0 rgba(0, 10, 30, 0.15);
                .bg {
                    background-color: var(--color-theme);
                    opacity: 0.4;
                }
            }
        }
        .swiper-prev {
            left: 5px;
            .iconfont {
                transform: translate(calc(-50% - 2px), -50%) rotate(180deg);
            }
        }
        .swiper-next {
            right: 5px;
        }
        .dot-mask {
            display: flex;
            justify-content: center;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 1;
        }
        .dot {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            margin: 5px 3px;
            background-color: rgba(255, 255, 255, 0.4);
            &.active {
                background: #fff;
            }
        }
    }
    @media (min-width: 601px) {
        &:hover {
            box-shadow: 0 8px 20px 0 rgba(0, 10, 30, 0.1);
            border: solid 1px var(--color-theme);
        }
    }
    .social-content {
        > .media {
            img {
                width: 100%;
                display: block;
            }
        }
        > .text {
            // text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
            line-height: 1.33;
            font-size: 12px;
            color: #202437;
            margin: 15px;
            padding: 0;
            overflow-wrap: break-word;
            word-break: break-word;

            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 6;
            max-height: 96px;
        }
        > .time-source {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: relative;
            color: #797e8b;
            height: 40px;
            box-sizing: content-box;
            border-top: 1px solid #dadada;
            padding: 0 15px;
            .time {
                font-size: 12px;
                line-height: 15px;
            }
            .source {
                font-size: 20px;
            }
            .icon-tiktok-round {
                background-image: url(https://cdn.chime.me/image/fs/sitebuild/2022828/19/original_04f465ef-ec7a-486f-a76f-6e2d369319c9.png);
                background-size: contain;
                background-repeat: no-repeat;
                width: 28px;
                height: 28px;
                border-radius: 50%;
            }
        }
    }
}
</style>
